import React, { useMemo } from 'react'
import { BtRadioGroup, BtInput } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { Spacer } from '../../../ui/atoms'
import { EnterManually } from '../components'

const BuiltFor = ({ model, value }) => {
  const { t } = useTranslation('global')
  const radioButtons = useMemo(() => {
    const options = [
      { label: t('ProjectForm.spec'), value: 'spec' },
      { label: t('ProjectForm.new-building'), value: 'newBuilding' },
      { label: t('ProjectForm.renovation'), value: 'renovation' },
    ]
    const otherValue = () => {
      const selected = options.find((op) => op.value === value)
      return selected ? '' : value
    }
    const onChange = (val) => model.setValue(val)
    return (
      <>
        <BtRadioGroup
          value={value}
          onChange={onChange}
          options={options}
          radioStyle={{ marginRight: 32 }}
          groupStyle={{ flexDirection: 'row', flexWrap: 'wrap' }}
          labelStyle={{ color: '#19262F', fontWeight: '500', fontSize: 16 }}
          testID="projectType_builtFor"
        />
        <Spacer height={10} />
        <BtInput
          value={otherValue()}
          onChangeText={onChange}
          testID="built-for-other"
          label={t('ProjectForm.other-label')}
        />
        <EnterManually />
      </>
    )
  }, [model, t, value])
  return radioButtons
}

export default {
  identifier: 'projectBuiltFor',
  title: 'Project is being built for:',
  component: BuiltFor,
}
